<template>
    <div class="not-ready" role="status" aria-live="polite" data-test="company-not-ready">
        <div class="not-ready__content">
            <v-progress-circular indeterminate size="56" width="4" color="primary" class="mb-6" />

            <h1 class="not-ready__title mb-3">Preparando o ata para a sua empresa</h1>

            <p class="not-ready__text mb-2">
                É a primeira vez que a sua empresa abre o ata. Estamos criando o espaço dela — leva poucos minutos, em geral até 2.
            </p>
            <p class="not-ready__support mb-6">
                Não precisa fazer nada: esta tela confere sozinha e abre o sistema assim que terminar.
            </p>

            <p class="not-ready__support mb-4" data-test="not-ready-countdown">
                {{ checking ? 'Verificando…' : `Verificando de novo em ${remaining} s` }}
            </p>

            <div class="d-flex justify-center flex-wrap ga-2">
                <v-btn color="primary" variant="tonal" :loading="checking" @click="check">Verificar agora</v-btn>
                <v-btn variant="text" @click="backToAdmin()">Voltar para o Admin</v-btn>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { getReadiness } from '@/services/api/ata/session.js';
import { waitSeconds } from '@/services/notReady.js';
import { backToAdmin } from '@/services/sso.js';

// Pagina de espera de uma corporacao recem-cadastrada (ver corporationNotReady.js). Pergunta a API, a cada `waitSeconds`, se as tabelas ja
// existem; quando existem, recarrega a pagina -- tudo o que as telas pediram enquanto isso foi respondido com o aviso e nunca chegou a resolver.
const remaining = ref(waitSeconds.value);
const checking = ref(false);
let timer = null;

async function check() {
    if (checking.value) return;

    checking.value = true;

    try {
        const response = await getReadiness();

        if (response?.ready) {
            window.location.reload();

            return;
        }
    } catch {
        // Sem resposta (rede, API reiniciando): continua tentando, a pessoa nao precisa ver erro nenhum.
    } finally {
        checking.value = false;
        remaining.value = waitSeconds.value;
    }
}

onMounted(() => {
    timer = setInterval(() => {
        if (checking.value) return;

        remaining.value -= 1;
        if (remaining.value <= 0) check();
    }, 1000);
});

onBeforeUnmount(() => clearInterval(timer));
</script>

<style scoped>
/* Cobre a tela inteira, menu e cabecalho inclusos: a pessoa nao tem nada util a clicar enquanto a empresa nao esta pronta. */
.not-ready {
    position: fixed;
    inset: 0;
    z-index: 3000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: var(--ata-surface);
}

.not-ready__content {
    max-width: 520px;
    text-align: center;
}

.not-ready__title {
    font-size: 1.35rem;
    font-weight: 600;
    color: var(--ata-text-strong);
}

.not-ready__text {
    color: var(--ata-text-strong);
}

.not-ready__support {
    color: var(--ata-text-weak);
    font-size: 0.875rem;
}
</style>
